import React, { useState, useEffect } from "react";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import { useNavigate } from "react-router-dom";
import MultipleChoiceAssignment from "../../../components/StudentAssignments/MultipleChoiceAssignment";
import ShortQuestionAssignment from "../../../components/StudentAssignments/ShortQuestionAssignment";
import ComprehensiveQuestionAssignment from "../../../components/StudentAssignments/ComprehensiveQuestionAssignment";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { studentAssignmentStartAPI } from "../../../redux/features/courseSlice";
import { toast } from "react-hot-toast";
import { studentAssignmentCompleteAPI } from "../../../redux/features/courseSlice";
// import { usePrompt } from "../../../hooks/usePrompt";
import Notification from "../../../components/Notification/Notification";
import { adminAssignmentAPI } from "../../../redux/features/courseSlice";

const Assignments = () => {
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
    setTimeout(() => {
      window.location.reload();
    }, 100);
  };
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [allData, setAllData] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // Add loading state

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const assignmentStart = async (assignmentId) => {
    try {
      setIsLoading(true); // Set loading to true
      const res = await dispatch(
        studentAssignmentStartAPI({
          token: auth.token,
          assignment_Id: assignmentId,
        })
      ).unwrap();
      if (res && res?.success) {
        setAllData(res?.data);
      }
    } catch (error) {
      toast.error(error, {
        position: "top-center",
      });
    } finally {
      setIsLoading(false); // Reset loading state
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const adminAssignment = async (assignmentId) => {
    try {
      setIsLoading(true); // Set loading to true
      const res = await dispatch(
        adminAssignmentAPI({
          token: auth.token,
          assignment_Id: assignmentId,
        })
      ).unwrap();
      if (res && res?.success) {
        setAllData(res?.data);
      }
    } catch (error) {
      toast.error(error, {
        position: "top-center",
      });
    } finally {
      setIsLoading(false); // Reset loading state
    }
  };

  const assignmentCompleteFunc = async () => {
    try {
      const res = await dispatch(
        studentAssignmentCompleteAPI({
          assignment_Id: searchParams.get("id"),
          token: auth.token,
        })
      ).unwrap();
      if (res.success) {
        // goBack();
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (searchParams.get("id")) {
      if (searchParams.get("view") === "true") {
        adminAssignment(searchParams.get("id"));
      } else{
        assignmentStart(searchParams.get("id"));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (allData) {
        e.preventDefault();
        e.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [allData]);

  return (
    <>
      {/* Topbar */}
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <h3
            className="ah-heading-04 fw-bold black-800 me-29 mb-0 d-flex align-items-center gap-3 cursor-pointer"
            onClick={goBack}
          >
            <span className="icon-arrow-left"></span>Assignment
          </h3>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            <Notification />
          </div>
        </div>
      </div>
      {/* Render Loading or Component */}
      {allData && (
        <>
          {allData?.type === "multiple_choice" ? (
            <MultipleChoiceAssignment
              allData={allData}
              assignmentCompleteFunc={assignmentCompleteFunc}
            />
          ) : allData?.type === "short_answer" ? (
            <ShortQuestionAssignment
              data={allData}
              assignmentCompleteFunc={assignmentCompleteFunc}
            />
          ) : allData?.type === "comprehensive" ? (
            <ComprehensiveQuestionAssignment
              data={allData}
              assignmentCompleteFunc={assignmentCompleteFunc}
            />
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
};

export default Assignments;
